var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"to-top",attrs:{"aria-label":"Scroll to top"},on:{"click":_vm.handleScrollAction}},[_vm._v("\n\t↑\n")])}
var staticRenderFns = []

export { render, staticRenderFns }